import { Action } from '@ngrx/store';

/**
 * PrintActionTypes
 */
export const enum PrintActionTypes {
  LOAD_TAB_INDEX = '[Print] Load Tab Index',
  CLEAR_TAB_INDEX = '[Print] Clear Tab Index',
}

/**
 * LoadTabIndex
 */
interface LoadTabIndex extends Action {
  type: PrintActionTypes.LOAD_TAB_INDEX;
  payload: any;
}

/**
 * ClearTabIndex
 */
interface ClearTabIndex extends Action {
  type: PrintActionTypes.CLEAR_TAB_INDEX;
}

/**
 * PrintActions
 */
export type PrintActions = LoadTabIndex | ClearTabIndex;
